<template>
  <div
    id="element"
    class="register-status"
  >
    <div class="register-status--item">
      <Header/>
    </div>
    <vue-recaptcha
      ref="recaptcha"
      :sitekey="siteKey"
      size="invisible"
      @verify="sendEmail"
      @expired="onCaptchaExpired"
    />
    <div class="section-gray">
      <div class="section-white">
        <div class="register-status--title">
          <div style="margin-bottom: 32px;">
            <span class="status-name">
              {{ $t('send_confirm_email.send_confirm_email') }}
            </span>
          </div>
        </div>
        <div
          class="register-status--detail"
          v-html="$t('send_confirm_email.send_confirm_email_detail', [user.email])"
        />
        <b-button
          :loading="isLoading"
          class="send-email-btn"
          @click="executeRecaptcha"
        >
          {{ $t('send_confirm_email.send_confirm_email') }}
        </b-button>
      </div>
    </div>
    <div class="register-status--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import Service from './service'
import { kulapApi } from '@/resources'
import Header from '@/features/Header'
import Footer from '@/components/Footer'
import { showToastError } from '@/utils/helper'
import { RECAPTCHA_SITE_KEY } from '@/constants'

export default {
  name: 'SendConfirmationEmail',
  components: {
    Header,
    Footer,
    VueRecaptcha
  },
  data () {
    return {
      service: null,
      siteKey: RECAPTCHA_SITE_KEY,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  async created () {
    this.service = new Service({
      store: this.$store,
      kulapApi
    })
    if (Object.keys(this.user).length && this.user.isActive) {
      this.$router.push({ name: 'Exchange' })
    }
  },
  methods: {
    executeRecaptcha () {
      this.isLoading = true
      this.$refs.recaptcha.execute()
      this.$scrollTo('.register-status--item')
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
      this.isLoading = false
    },
    async sendEmail (recaptchaToken) {
      try {
        await this.service.sendConfirmationEmail(recaptchaToken)
        this.$buefy.toast.open({
          message: 'It has been done, please check your email.',
          type: 'is-success'
        })
      } catch (e) {
        showToastError(e)
      }
      this.$refs.recaptcha.reset()
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.register-status {
  float: left;
  width: 100%;
  min-height: 100vh;

  &--item {
    float: left;
    width: 100%;
  }

  &--title {
    margin: 0 0 25px 0;
    font-size: 21px;
    font-weight: bold;
    text-align: center;
    color: #000000;
  }

  &--detail {
    color: grey;
    text-align: center;
  }
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 170px;
  text-align: center;
}
.section-white {
  display: inline-block;
  padding: 32px 47px;
  width: fit-content;
  border-radius: 5px;
  box-shadow: 0 2px 4px -3px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  text-align: left;
  max-width: 450px;
}
.status-logo {
  width: 37px;
  vertical-align:middle
}
.status-name {
  font-size: 27px;
  font-weight: bold;
  vertical-align:middle
}
.send-email-btn {
  margin-top: 25px;
  float: left;
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: #0458af;
  padding: 20px 10px;
  font-weight: bold;
  border-radius: 3px;
  border: unset;
  cursor: pointer;
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .section-gray {
    padding-bottom: 1rem;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .section-white {
    width: 95vw;
    max-width: calc(100vw - 20px);
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SendConfirmationEmail/index.vue